import { render, staticRenderFns } from "./airPayPage.vue?vue&type=template&id=34d584f6&scoped=true&"
import script from "./airPayPage.vue?vue&type=script&lang=js&"
export * from "./airPayPage.vue?vue&type=script&lang=js&"
import style0 from "./airPayPage.vue?vue&type=style&index=0&id=34d584f6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d584f6",
  null
  
)

export default component.exports